/***
 *
 *   SUPPORT LINK CARD STYLES
 *
 **********/

const Style = {
    hint: 'text-sm leading-relaxed text-text-secondary',
    warning: 'text-sm font-medium text-warning',
    secretBlock: 'mt-4 space-y-2 rounded-md border border-warning/40 bg-warning/5 p-4',
    row: 'flex flex-col gap-2 sm:flex-row sm:items-center',
    secretInput: `h-10 w-full rounded-md border border-input bg-surface px-3 py-2 font-mono text-xs
    text-text-primary shadow-sm`,
    footer: 'mt-3',
    steps: 'list-decimal space-y-6 pl-5 text-text-primary marker:font-semibold marker:text-text-muted',
    step: 'space-y-2',
    stepTitle: 'text-sm font-semibold text-text-primary',
    snippetHeader: 'mt-2 flex justify-end',
    pre: `overflow-x-auto rounded-md border border-border bg-surface-elevated p-3 font-mono
    text-xs leading-relaxed text-text-primary`,
    advanced: 'mt-6 border-t border-border pt-4',
    advancedSummary: 'cursor-pointer text-sm font-medium text-text-secondary hover:text-text-primary',
};

export default Style;
